import TickIcon from './TickIcon';

export default TickIcon;
